module.exports = "\n<div class=\"post\">\n  <div ng-include=\"'posts.post-inner'\"></div>\n</div>\n";